"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatus = void 0;
var JobStatus;
(function (JobStatus) {
    JobStatus["ACCEPTED"] = "accepted";
    JobStatus["AFTER_PHOTO_TAKEN"] = "after_photo_taken";
    JobStatus["BEFORE_PHOTO_TAKEN"] = "before_photo_taken";
    JobStatus["CANCELED"] = "canceled";
    JobStatus["CUSTOMER_CALLED"] = "customer_called";
    JobStatus["DISPATCHED"] = "dispatched";
    JobStatus["DONE"] = "done";
    JobStatus["DONE_WAITING_INVOICE"] = "done_waiting_invoice";
    JobStatus["EXTERNAL_DISPATCH"] = "external_dispatch";
    JobStatus["NEW"] = "new";
    JobStatus["NEW_QUOTE"] = "new_quote";
    JobStatus["ON_MOVE"] = "on_move";
    JobStatus["PLANNED"] = "planned";
    JobStatus["PROXY_FAILED"] = "proxy_failed";
    JobStatus["STARTED"] = "started";
    JobStatus["TO_DISPATCH"] = "to_dispatch";
    JobStatus["TO_DISPATCH_2"] = "to_dispatch_2";
    JobStatus["TO_REDISPATCH"] = "to_redispatch";
    JobStatus["WAITING_PROXY"] = "waiting_proxy";
    JobStatus["TO_DISPATCH_MANUALLY"] = "to_dispatch_manually";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
//# sourceMappingURL=job.js.map